export enum TipoAtualizacaoEnum {
  APROVAR = 1,
  REJEICAO = 10,
}

export enum TipoAcordoEnum {
  PRECO_FIXO = 2,
  ACRESCIMO = 4,
  DESCONTO = 5,
}
